import React, { useEffect, useState } from 'react';

import { UserClaims } from '@okta/okta-auth-js';
import { useOktaAuth } from '@okta/okta-react';

import { UserContext } from './context';
import { UserInfo } from '../../models/IUserDetails';
import { GetOktUserToken } from '../../services/okta-service';
import { GetUserDetails } from '../../services/user-service';

/**
 * A read-only context for User information.
 * It will forget any user info when user isn't authenticated.
 * Update userInfo when authState or oktaAuth changes.
 * @param { children } props  – React props with children
 */
export const User: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    const { authState, oktaAuth } = useOktaAuth();
    const [userInfo, setUserInfo] = useState<UserInfo | undefined>();
    useEffect(() => {
        if (authState?.isAuthenticated) {
            oktaAuth.getUser().then((info: UserClaims) => {
                if (info) {
                    GetOktUserToken().then(res => {
                        sessionStorage.setItem('passplay-token', res.data);
                        GetUserDetails().then(pRes => {
                            setUserInfo({ oktaUser: info, passplayUser: pRes.data });
                        })
                    });
                }
            });
        } else {
            setUserInfo(undefined);
        }
    }, [authState, oktaAuth]);

    return <UserContext.Provider value={userInfo}>{children}</UserContext.Provider>;
};
